
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"gst-svg-icon",attrs:{"d":"M4 2v-.333a1 1 0 012 0V2h4v-.333a1 1 0 012 0V2h2.333a1 1 0 011 1v11.334a1 1 0 01-1 1H1.667a1 1 0 01-1-1V3a1 1 0 011-1H4zm0 .667H1.667A.333.333 0 001.333 3v2.334h13.334V3a.333.333 0 00-.334-.333H12V3a1 1 0 01-2 0v-.333H6V3a1 1 0 11-2 0v-.333zM1.333 6v8.334a.333.333 0 00.334.333h12.666a.333.333 0 00.334-.333V6H1.333zm2 1.334h1.334A.667.667 0 015.333 8v1.334a.667.667 0 01-.666.666H3.333a.667.667 0 01-.666-.666V8a.667.667 0 01.666-.666zm0 .666v1.334h1.334V8H3.333zM11 3.334A.333.333 0 0011.333 3V1.667a.333.333 0 10-.666 0V3a.333.333 0 00.333.334zm-6 0A.333.333 0 005.333 3V1.667a.333.333 0 00-.666 0V3A.333.333 0 005 3.334z","fill":"#50657c"}})])
          )
        }
      }
    